export default {
  values: {
    notAllowed: 'not-allowed',
    optional: 'optional',
    required: 'required',
  },
  labels: {
    notAllowed: 'Niet toegestaan',
    optional: 'Optioneel',
    required: 'Verplicht',
  },
  getOptions() {
    return Object.keys(this.values).map(value => ({
      value: this.values[value],
      label: this.labels[value],
    }));
  },
  getLabel(value) {
    return this.getOptions().find(function (option) {
      return option.value === value;
    }).label;
  }
};